import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys, uuidRegEx } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { InventoryItemsDropdownProps, InventoryItemsDropdownRespSuccess } from './types';
import { useAppContext } from '@contexts/app';

export const useInventoryItemsDropdown = ({ jobId, dialog }: InventoryItemsDropdownProps) => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { parseParams } = useQueryParams();

  const queryParams = parseParams({ jobId: dialog ? jobId : undefined });

  const { data, error, isPending } = useQuery<InventoryItemsDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.inventoryItems, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/inventory_items${queryParams}` }),
    placeholderData: (previousData) => previousData as InventoryItemsDropdownRespSuccess,
    enabled: enabled && Boolean(jobId && uuidRegEx.test(jobId)),
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled && Boolean(jobId && uuidRegEx.test(jobId)),
  };
};
